// Stable Sentry fingerprints for known error families whose default
// stack-based grouping rotates with every release: minified frames shift, so
// one failure mode splits across new issue fingerprints each deploy and
// archived-until-escalating never sticks. Matching is message-based because
// beforeSend sees raw minified frames — function names are mangled and
// sourcemapped paths don't exist client-side.
//
// Only add families that are (a) a single semantic failure and (b) carry a
// distinctive message. Generic messages (e.g. "too much recursion") cover
// genuinely different bugs and must NOT be pinned to one issue.

const FAMILIES = [
  {
    // @codemirror/language's parse worker dispatches during an update —
    // upstream bug, zero first-party frames (FRONTEND-8VT/8T3).
    fingerprint: 'codemirror-editorview-update-reentrancy',
    test: message => message.includes(
      'Calls to EditorView.update are not allowed while an update is in progress',
    ),
  },
  {
    // CodeMirror IME composition crash in TileBuilder.addComposition
    // (FRONTEND-8SR/8SS/8TQ). Firefox's phrasing embeds a minified local
    // (`e.line`, `t.line`, ...), so match any identifier. Chrome's phrasing
    // ("Cannot read properties of null (reading 'dom')") is too generic to
    // claim for this family.
    fingerprint: 'codemirror-composition-line-null',
    test: message => /can't access property "dom", \w+\.line is null/.test(message),
  },
];

// Returns the stable fingerprint key for a known family, or null to leave
// the event on Sentry's default grouping.
export const familyFingerprint = (message) => {
  if (typeof message !== 'string') {
    return null;
  }
  const family = FAMILIES.find(f => f.test(message));
  return family ? family.fingerprint : null;
};

export default familyFingerprint;
